export default __webpack_public_path__ + "images/svg-sprite/wave-bottom-5-overlay.svg";